import { useContext } from "react";
import { SortableColumnContext } from "../context";

export const useSortableColumn = () => useContext(SortableColumnContext);
